<template>
  <b-tab>
    <template v-slot:title>
      {{ $t('Vendor Charges') }}
    </template>
    <VendorChargesTable/>
  </b-tab>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import VendorChargesTable from "@/modules/vendor-charges/VendorChargesTable";

  const {mapState, mapActions} = createNamespacedHelpers('vendorCharges');
  const {mapState: mapStateBranch} = createNamespacedHelpers('setup/branch');

  export default {
    name: "VendorCharges",
    components: {VendorChargesTable},
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource]
      }),
      ...mapStateBranch({
        branch: state => state.selectedBranch
      })
    },
    methods: {
      ...mapActions(['updateTableSource', 'getTableData']),
    },
    watch: {
      branch() {
        this.updateTableSource({
          source: 'branch',
          sourceUuid: this.branch.uuid
        });
        this.getTableData();
      }
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'branch',
        sourceUuid: this.branch.uuid
      });
      this.getTableData();
    }
  }
</script>

<style lang="scss" scoped>
</style>
